import styled from '@emotion/styled';
import { Dialog } from '@mui/material';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: 461,
  },
}));

export const ModalContent = styled.div((_) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  padding: 10,
}));

export const ExclamationSection = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  fontSize: 13,
  fontWeight: 400,
  gap: 8,
  padding: '0px 16px',
}));

export const Section = styled.div((_) => ({
  padding: 16,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
}));

export const ThemedSection = styled(Section)(({ theme }) => ({
  backgroundColor: theme.colors.highlight,
  borderRadius: 5,
}));

export const Field = styled.div((_) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
}));

export const Label = styled.div((_) => ({
  fontSize: 13,
  fontWeight: 400,
}));

export const Value = styled.div((_) => ({
  fontSize: 13,
  fontWeight: 600,
}));

export const ErrorText = styled.div(({ theme }) => ({
  fontSize: 13,
  color: theme.colors.error.main,
}));

export const ErrorInfo = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: theme.colors.primary,
  gap: 16,
  path: {
    fill: theme.colors.primary,
  },
  h3: {
    fontSize: 16,
    fontWeight: 600,
    margin: 0,
  },
  p: {
    fontSize: 13,
    fontWeight: 400,
    textAlign: 'center',
  },
}));
